module.exports = __webpack_public_path__ + "static/media/bg2.40ef31ca.jpg";